var generateStyle = function generateStyle(componentTheme) {
  return {
    checkboxWrapper: {
      padding: "".concat(componentTheme.checkboxWrapperPadding, " 0")
    },
    checkboxesWrapper: {
      width: '95%',
      marginLeft: 'auto'
    },
    deleteStimulusModal: {
      stimulusTitle: {
        paddingBottom: componentTheme.stimulusTitleBottomPadding,
        fontSize: componentTheme.stimulusTitleFontSize
      }
    },
    radioSpace: {
      paddingBottom: componentTheme.radioSpaceBottomPadding
    }
  };
};
export default generateStyle;